import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { BASE_URL } from "../../utils/constant";
import logo from "../../assets/image/logo.jpeg";

const OTPVerification = () => {
  const navigate = useNavigate();
  const [otp, setOTP] = useState(["", "", "", ""]);
  const [isValidOTP, setIsValidOTP] = useState(true);
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const email_or_phone = localStorage.getItem("email_or_phone");

  const handleOTPChange = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[e.target.dataset.index] = value;
      setOTP(newOtp);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (otp.length === 4 && otp.every((digit) => digit !== "")) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BASE_URL}/users/verify_otp/`,
          { otp: otp.join(""), email_or_phone },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (response && response.data && response.data.message) {
          toast.success("OTP verified successfully.");

          localStorage.setItem(
            "user_permissions",
            response?.data?.user_details?.user_permissions,
          );
          localStorage.setItem("token", response.data.access_token);
          localStorage.setItem(
            "type",
            response.data?.user_details?.industry_type,
          );
          localStorage.setItem("punch_in", response.data.punch_in);
          localStorage.setItem("role", response?.data?.user_details?.role);
          localStorage.setItem(
            "attendence_type",
            response?.data?.user_details?.attendence_type,
          );
          localStorage.setItem("userId", response?.data?.user_details?.id);
          navigate("/dashboard");
          localStorage.removeItem("email_or_phone");
          window.location.reload();
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.non_field_errors
          ? error.response.data.non_field_errors.join(", ")
          : "An error occurred during OTP verification.";
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    } else {
      setIsValidOTP(false);
    }
  };

  const handleResendOTP = async () => {
    setResending(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/users/resend_otp/`,
        { email_or_phone },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response && response.data && response.data.message) {
        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "An error occurred while resending OTP.",
      );
    } finally {
      setResending(false);
    }
  };

  const inputRefs = useRef([]);

  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOTP(newOtp);

      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, 4);
    if (/^\d+$/.test(pasteData)) {
      const newOtp = pasteData.split("");
      setOTP(newOtp);
      if (newOtp.length === 4) {
        inputRefs.current[3].focus();
      }
    }
  };
  return (
    <section className="vh-100 d-flex justify-content-center align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-6 col-12">
            <div
              className="card border-0 shadow-lg overflow-hidden rounded-5"
              style={{ backgroundColor: "rgba(255, 255, 255, 0.95)" }}
            >
              <div className="row g-0">
                <div
                  className="col-md-6 d-none d-md-flex"
                  style={{
                    background: "linear-gradient(135deg, #007bff, #0056b3)",
                    flex: "1",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={logo}
                    alt="Logo"
                    className="img-fluid"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="col-md-12 col-12 col-lg-6">
                  <div className="card-body p-4">
                    <h3
                      className="card-title text-center fw-bold mb-4"
                      style={{ fontSize: "1.8rem" }}
                    >
                      Verify Your Account
                    </h3>
                    <p
                      className="text-center mb-4"
                      style={{ fontSize: "1rem", color: "#555" }}
                    >
                      A 4-digit OTP has been sent to your email or phone number.
                    </p>
                    <form onSubmit={handleFormSubmit}>
                      <div className="otp-inputs mb-4 d-flex justify-content-center gap-2">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            type="text"
                            value={digit}
                            maxLength="1"
                            onChange={(e) =>
                              handleChange(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                            className="otp-input"
                            data-index={index}
                            style={{
                              width: "3rem",
                              height: "3rem",
                              textAlign: "center",
                            }}
                          />
                        ))}
                      </div>

                      <div className="btn-container d-flex justify-content-end mt-4">
                        <button className="login-btn" disabled={loading}>
                          {loading ? (
                            <div
                              className="spinner-border text-light"
                              role="status"
                              style={{ width: "1rem", height: "1rem" }}
                            ></div>
                          ) : (
                            "Verify"
                          )}
                        </button>
                      </div>

                      <p className="text-center mt-3">
                        Didn’t get the code?{" "}
                        <span
                          onClick={handleResendOTP}
                          style={{ cursor: "pointer" }}
                          disabled={resending}
                          className="Link"
                        >
                          {resending ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Resend"
                          )}
                        </span>
                      </p>

                      <div
                        className="rounded-circle d-flex justify-content-center align-items-center text-white mx-auto mt-4"
                        style={{
                          width: "40px",
                          height: "40px",
                          cursor: "pointer",
                          backgroundColor: "#1f7cff",
                        }}
                        onClick={() => navigate("/signin")}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OTPVerification;
